export const REVERT_RMA_REQUEST = "REVERT_RMA_REQUEST";
export const REVERT_RMA_RESULT = "REVERT_RMA_RESULT";
export const REVERT_RMA_OPEN_MODAL = "REVERT_RMA_OPEN_MODAL";
export const REVERT_RMA_CLOSE_MODAL = "REVERT_RMA_CLOSE_MODAL";
export const REVERT_RMA_GET_DEVICE_REQUEST = "REVERT_RMA_GET_DEVICE_REQUEST";
export const REVERT_RMA_GET_DEVICE_RESULT = "REVERT_RMA_GET_DEVICE_RESULT";

export const REVERT_RMA_SET_DEVICE = "REVERT_RMA_SET_DEVICE";

